// extracted by mini-css-extract-plugin
module.exports = {"active":"Arrow_active__g3LnD","arrow":"Arrow_arrow__BHLCH","arrowDisabled":"Arrow_arrowDisabled__yL29M","leftArrow":"Arrow_leftArrow__kcx10","rightArrow":"Arrow_rightArrow__h4AcE"};